import { Component, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { DefaultDataService } from 'src/app/services/default-data.service';
import { EventService } from 'src/app/services/event.service';


@Component({
  selector: 'fuse-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FuseFooterComponent implements OnDestroy {
  appName: string;
  appVersion: string;
  appCopyright: string;

  onDefaultDataChanged$: Subscription;

  constructor(private defaultData: DefaultDataService, private events: EventService
  ) {
    if (defaultData) {
      this.appName = defaultData.AppTitle;
      this.appVersion = defaultData.WebAPIVersion;
      this.appCopyright = defaultData.Copyright;
    }

    this.onDefaultDataChanged$ = this.events.onDefaultDataChanged.subscribe(r => {     
      if (r) {
        this.appName = r.AppTitle;
        this.appVersion = r.WebAPIVersion;
        this.appCopyright = r.Copyright;
      }
    });
  }

  ngOnDestroy() {
    if (this.onDefaultDataChanged$) {
      this.onDefaultDataChanged$.unsubscribe();
    }
  }
}
